<template>
  <b-container fluid style="padding:0;">
    <div class="header-tab" v-if="coureurs_in_course">
      <b-row style="margin-bottom:25px;">
        <b-col cols="4"><a href="https://sportips.fr"><img src="../assets/logo.png"
              style="width:100%;height:auto;max-width:200px;" /></a></b-col>
        <b-col cols="8">
          <h2 style="margin-top:15px;font-weight:bold;" v-if="epreuve">
            <v-icon style="color:#f29406" name="running" scale="2" />
            {{ epreuve.nom }}
            <div style="width:60%;height:3px; background-color:#f29406;margin:15px 20%;"></div>
          </h2>
          <h3 v-if="epreuve">{{ epreuve.date }} - {{ epreuve.ville }}</h3>
        </b-col>
      </b-row>
      <b-row style="margin-bottom:25px;">
        <b-col md="4" style="text-align:center;">
          <h3>Course :</h3>
          <b-button class="button_course" v-bind:class="{
            isCurrent: currentParcours === p
          }" v-for="p in list_parcours" :key="p"><router-link target="_self" :to="{
            name: 'AncienneEpreuve',
            query: { id: id_epreuve, p: p }
          }" refresh>{{ p }}</router-link></b-button>
        </b-col>
        <b-col md="2">
          <h3>Catégorie :</h3>
          <b-form-select v-model="filterCat" :options="list_cat"></b-form-select>
        </b-col>
        <b-col md="2">
          <h3>Sexe :</h3>
          <b-button-group>
            <b-button v-on:click="filterSexe = ''" v-bind:class="{ isCurrent: filterSexe === '' }">
              <v-icon name="male" />
              <v-icon name="female" />
            </b-button>
            <b-button v-on:click="filterSexe = 'M'" v-bind:class="{ isCurrent: filterSexe === 'M' }">
              <v-icon name="male" />
            </b-button>
            <b-button v-on:click="filterSexe = 'F'" v-bind:class="{ isCurrent: filterSexe === 'F' }">
              <v-icon name="female" />
            </b-button>
          </b-button-group>
        </b-col>
        <b-col md="2">
          <h3>Nom :</h3>
          <b-form-input v-model="keyword" placeholder="Rechercher..."></b-form-input>
        </b-col>
        <b-col md="2">
          <h3>Club :</h3>
          <b-form-select v-model="filterClub" :options="list_clubs"></b-form-select>
          <!-- <b-form-input v-model="filterClub" placeholder="Rechercher..."></b-form-input> -->
        </b-col>
      </b-row>
    </div>
    <div class="header-tab" v-if="coureurs_in_course">
      <b-row style="margin-bottom:20px;">
        <b-col>
          <p style="text-align:left;font-weight:bold;margin-top:10px;">
            {{ infos_inscriptions }}
          </p>
        </b-col>
        <b-col>
          <span style="font-weight:bold;">Télécharger cette sélection : </span>
          <b-button-group>
            <b-button v-on:click="downloadCSV" style="margin-right:5px;">
              <v-icon name="download" scale="2" /> CSV</b-button>

            <form v-if="epreuve.nom" action="https://sportips.fr/plateformeResultats/telechargementAnciens.php"
              method="POST" target="_blank">

              <input type="hidden" name="id_epreuve" :value="id_epreuve" />
              <input type="hidden" name="parcours" :value="parcours" />
              <input type="hidden" name="epreuve" :value="JSON.stringify(this.epreuve)" />
              <input type="hidden" name="data" :value="JSON.stringify(this.itemsForPdf())" />

              <b-button type="submit">
                <v-icon name="download" scale="2" /> PDF</b-button>
            </form>
          </b-button-group>
        </b-col>
      </b-row>
    </div>

    <h1 style="text-align:center;" v-if="coureurs_in_course.length === 0">
      Résultats en attente de publication...
    </h1>
    <b-table striped hover small outlined :items="coureurs_in_course" :fields="fields" v-if="coureurs_in_course"
      @row-clicked="openModal" sort-by="clt" responsive>
      <template slot="cell(clt)" slot-scope="data">
        {{ data.item.classement }}
      </template>
      <template slot="cell(nom)" slot-scope="data">
        <span v-if="data.item.sexe === 'M'" style="color:#000080;font-weight:bold;">{{ data.item.nom }} {{
          data.item.prenom }}</span>
        <span v-else style="color:#800080;font-weight:bold;">{{ data.item.nom }} {{ data.item.prenom }}</span>
      </template>
      <template slot="cell(doss)" slot-scope="data">
        {{ data.item.numero }}
      </template>
      <template slot="cell(nat)" slot-scope="data">
        <img :src="'https://sportips.fr/live/img/Flags/' + data.item.flag" />
      </template>
      <template slot="cell(classement_cat)" slot-scope="data">
        {{ data.item.classement_cat }} {{ data.item.abbrev_categorie }}
      </template>
      <template slot="cell(classement_sexe)" slot-scope="data">
        {{ data.item.classement_sexe }} {{ data.item.sexe }}
      </template>
      <template slot="cell(temps_arrondi)" slot-scope="data">
        <span class="temps_tab">{{ data.item.temps_arrondi }}</span>
      </template>
      <template slot="cell(ecart)" slot-scope="data">
        <p style="white-space:nowrap;">
          {{ getFirst(data.item.temps_arrondi) }}
        </p>
      </template>
      <template slot="cell(plus)" slot-scope="data">
        <b-button @click="openModal(data.item, 0)">
          <v-icon name="info" />
        </b-button>
      </template>
    </b-table>
    <b-modal ref="my-modal" size="xl" :title="selectedCoureur.nom + ' ' + selectedCoureur.prenom
      " hide-footer>
      <div class="container">
        <b-row>
          <b-col md="2">
            <p>Dossard</p>
            <p class="modal-res">{{ selectedCoureur.numero }}</p>
          </b-col>
          <b-col md="2">
            <p>Course</p>
            <p class="modal-res">{{ selectedCoureur.course }}</p>
          </b-col>
          <b-col md="2">
            <p>Catégorie</p>
            <p class="modal-res">{{ selectedCoureur.nom_categorie }}</p>
          </b-col>
          <b-col md="2">
            <p>Sexe</p>
            <p class="modal-res">
              <span v-if="selectedCoureur.sexe == 'F'">Femme</span><span v-if="selectedCoureur.sexe == 'M'">Homme</span>
            </p>
          </b-col>
          <b-col md="2">
            <p>Club</p>
            <p class="modal-res">{{ selectedCoureur.club }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <h3>Résultats</h3>
            <div class="line-heading"></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="1">
            <p>Clt</p>
            <p class="modal-res">{{ selectedCoureur.classement }}</p>
          </b-col>
          <b-col md="2">
            <p>Temps</p>
            <p class="modal-res">{{ selectedCoureur.temps_arrondi }}</p>
          </b-col>
          <b-col md="2">
            <p>Vitesse</p>
            <p class="modal-res">{{ selectedCoureur.moyenne }}km/h</p>
          </b-col>
          <b-col md="2">
            <p>Allure</p>
            <p class="modal-res">{{ selectedCoureur.rythme }}min/km</p>
          </b-col>
          <b-col md="2">
            <p>Clt cat</p>
            <p class="modal-res">
              {{ selectedCoureur.classement_par_cat }}
              {{ selectedCoureur.abbrev_categorie }}
            </p>
          </b-col>
          <b-col md="2">
            <p>Clt sexe</p>
            <p class="modal-res">
              {{ selectedCoureur.classement_par_sexe }}
              {{ selectedCoureur.sexe }}
            </p>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-container>
</template>
<script>
import axios from "axios";
import Papa from "papaparse";
export default {
  props: ["id", "p"],
  data() {
    return {
      id_epreuve: 0,
      parcours: "",
      coureurs: [],
      coureur_in_course: [],
      list_parcours: [],
      currentParcours: "",
      list_cat: ["Toutes"],
      filterCat: "Toutes",
      list_clubs: [],
      filterClub: "",
      filterSexe: "",
      keyword: "",
      fields: [
        { key: "clt", label: "Clt", sortable: false },
        { key: "nom", label: "Nom - Prénom", sortable: false },
        { key: "doss", label: "Doss.", sortable: false },
        { key: "nat", label: "Nat", sortable: false },
        { key: "classement_cat", label: "Clt Cat", sortable: false },
        { key: "classement_sexe", label: "Clt Sexe", sortable: false },
        { key: "temps_arrondi", label: "Temps", sortable: false },
        { key: "ecart", label: "Ecart", sortable: false },
        { key: "moyenne", label: "Moy.", sortable: false },
        { key: "club", label: "Club", sortable: false },
        { key: "licence", label: "Licence", sortable: false },
        { key: "plus", label: "Plus", sortable: false }
      ],
      epreuve: {},
      selectedCoureur: {},
      infos_inscriptions: "",
      /*--------------------------------*/



    };
  },
  computed: {
    /* Coureur list for a specified parcours */
    coureurs_in_course() {
      var filtered_coureurs = this.coureurs;
      if (this.parcours) {
        filtered_coureurs = filtered_coureurs.filter(item =>
          item.course.includes(this.parcours)
        );
      }
      if (this.keyword) {
        filtered_coureurs = filtered_coureurs.filter(
          item =>
            item.nom.includes(this.keyword.toUpperCase()) ||
            item.numero.includes(this.keyword)
        );
      }
      if (this.filterSexe) {
        filtered_coureurs = filtered_coureurs.filter(item =>
          item.sexe.includes(this.filterSexe)
        );
      }
      if (this.filterClub) {
        filtered_coureurs = filtered_coureurs.filter(item =>
          item.club.includes(this.filterClub)
        );
      }
      if (this.filterCat != "" && this.filterCat != "Toutes") {
        filtered_coureurs = filtered_coureurs.filter(item =>
          item.abbrev_categorie == this.filterCat
        );
      }

      return filtered_coureurs;
    }
  },

  methods: {
    downloadCSV() {
      var dataToCsv = [];
      for (var i = 0; i < this.coureurs_in_course.length; i++) {
        var r = this.coureurs_in_course[i];
        var currentFields = this.fields;
        var currentData = {};
        for (var j = 0; j < currentFields.length; j++) {
          if (currentFields[j].label === "Ecart") {
            currentData[currentFields[j].label] = this.getFirst(r["temps_arrondi"]);
          } else if (currentFields[j].label === "Clt") {
            currentData[currentFields[j].label] = r["classement"];
          } else if (currentFields[j].label === "Nom - Prénom") {
            currentData[currentFields[j].label] = r["nom"] + " " + r["prenom"];
          } else if (currentFields[j].label === "Doss.") {
            currentData[currentFields[j].label] = r["numero"];
          } else if (currentFields[j].label === "Clt Cat") {
            currentData[currentFields[j].label] = r["classement_cat"] + " " + r["abbrev_categorie"];
          } else if (currentFields[j].label === "Clt Sexe") {
            currentData[currentFields[j].label] = r["classement_sexe"] + " " + r["sexe"];
          } else if (currentFields[j].label === "Temps") {
            currentData[currentFields[j].label] = r["temps_arrondi"];
          } else if (currentFields[j].label === "Moy.") {
            currentData[currentFields[j].label] = r["moyenne"];
          } else if (currentFields[j].label === "Club") {
            currentData[currentFields[j].label] = r["club"];
          }
          else if (currentFields[j].label === "Licence") {
            currentData[currentFields[j].label] = r["licence"];
          }
        }
        dataToCsv.push(currentData);
      }


      var csv = Papa.unparse(dataToCsv, { delimiter: ";" });

      var csvData = new Blob(["\ufeff", csv], {
        type: "text/csv;charset=utf-8;"
      });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "download.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute(
        "download",
        "Résultats-Sportips " + this.epreuve.nom + ".csv"
      );
      tempLink.click();
    },

    itemsForPdf() {
      var iPDF = [];
      for (var i = 0; i < this.coureurs_in_course.length; i++) {
        var c = this.coureurs_in_course[i];


        iPDF.push([
          c["classement"],
          c["nom"] + " " + c["prenom"],
          c["numero"],
          c["classement_cat"] + " " + c["abbrev_categorie"],
          c["temps_arrondi"],
          c["club"],
          c["flag"],
          c["moyenne"],
          this.getFirst(c["temps_arrondi"]),
          c["sexe"],
          c["classement_sexe"] + " " + c["sexe"]
        ]);

      }
      return iPDF;
    },
    downloadPDF() {
      var data = new FormData();
      data.append("id_epreuve", this.id_epreuve);
      data.append("epreuve", JSON.stringify(this.epreuve));
      data.append("data", JSON.stringify(this.itemsForPdf()));
      data.append("parcours", this.parcours);
      axios
        .post(
          `https://sportips.fr/plateformeResultats/telechargementAnciens.php`,
          data
        )
        .then(function (response) { });
    },


    /* Get time offset between time t and first in clt */
    getFirst(t) {
      if (t === this.coureurs_in_course[0].temps_arrondi || t == null) {
        return "";
      } else {
        var t2 = this.coureurs_in_course[0].temps_arrondi.split(":");
        var t1 = t.split(":");
        var diff =
          parseInt(t1[0]) * 3600 +
          parseInt(t1[1]) * 60 +
          parseInt(t1[2]) -
          (parseInt(t2[0]) * 3600 + parseInt(t2[1]) * 60 + parseInt(t2[2]));
        var heure = Math.floor(diff / 3600);
        var heurerest = diff % 3600;
        var minute = Math.floor(heurerest / 60);
        var sec = heurerest % 60;
        var res = "+ " + heure + "h" + minute + "m" + sec + "s";

        return res;
      }
    },
    /* Handle infos in modal and open modal onclick row or button more infos */
    openModal(data, index) {
      this.selectedCoureur = data;

      var rythme =
        parseInt(this.selectedCoureur.nb_secondes_arrondi) /
        60 /
        parseInt(this.selectedCoureur.distance.replace(",", "."));
      rythme = (rythme - Math.floor(rythme)) * 0.6 + Math.floor(rythme);
      this.selectedCoureur.depart = "12:00:00";
      this.selectedCoureur.heure_arrivee = "12:00:00";
      this.selectedCoureur.nb_coureur_in_cat = this.getNbCoureurInCat();
      this.selectedCoureur.nb_coureur_in_sexe = this.getNbCoureurInSexe();

      this.selectedCoureur.rythme = rythme.toFixed(2);
      this.$refs["my-modal"].show();
    },
    /* Get nb coureurs in cat for modal */
    getNbCoureurInCat() {
      var c = this.coureurs_in_course.filter(
        item =>
          item.categorie.includes(this.selectedCoureur.categorie) &&
          item.sexe.includes(this.selectedCoureur.sexe)
      );
      return c.length;
    },
    /* Get nb coureurs in sexe for modal */
    getNbCoureurInSexe() {
      var c = this.coureurs_in_course.filter(item =>
        item.sexe.includes(this.selectedCoureur.sexe)
      );
      return c.length;
    },
    /* Handle page reload onclick button parcours */
    reloadPage(page) {
      var data = new FormData();
      var _this = this;
      this.id_epreuve = this.$route.query.id;
      this.parcours = this.$route.query.p;
      data.append("id_epreuve", this.id_epreuve);
      axios
        .post(
          `https://sportips.fr/plateformeResultats/getAncienneEpreuve.php`,
          data
        )
        .then(function (response) {
          _this.coureurs = response.data;
          _this.epreuve.nom = _this.coureurs[0].competition;
          _this.epreuve.ville = _this.coureurs[0].ville_compet;
          _this.epreuve.date = _this.coureurs[0].date_compet;
          _this.buildListParcours();
          _this.buildListCategories();
          _this.buildListClubs();
          _this.getInscritsInfos();
        });
    },
    /* Build list parcours for button select header */
    buildListParcours() {
      if (this.parcours) {
        this.currentParcours = this.parcours;
      } else {
        this.currentParcours = this.coureurs[0].course;
      }
      var _this = this;
      this.coureurs.forEach(function (coureur, index) {
        if (!_this.list_parcours.includes(coureur.course)) {
          _this.list_parcours.push(coureur.course);
        }
      });
    },
    /* Build list category for select header */
    buildListCategories() {
      var _this = this;
      this.coureurs.forEach(function (coureur, index) {
        if (!_this.list_cat.includes(coureur.abbrev_categorie)) {
          _this.list_cat.push(coureur.abbrev_categorie);
        }
      });
    },
    /* Build list clubs for select header */
    buildListClubs() {
      var _this = this;
      this.coureurs.forEach(function (coureur, index) {
        if (!_this.list_clubs.includes(coureur.club)) {
          _this.list_clubs.push(coureur.club);
        }
      });
    },
    /* Return string inscriptions infos (abandon,parti ...) */
    getInscritsInfos() {
      var data = new FormData();
      var _this = this;
      data.append("id_epreuve", this.id_epreuve);
      data.append("parcours", this.parcours);
      axios
        .post(
          `https://sportips.fr/plateformeResultats/getAnciensNbInscrits.php`,
          data
        )
        .then(function (response) {
          _this.infos_inscriptions = response.data;
        });
    }
  },

  // Called when rendering page

  mounted: function () {
    var data = new FormData();
    var _this = this;
    this.id_epreuve = this.$route.query.id;
    this.parcours = this.$route.query.p;
    data.append("id_epreuve", this.id_epreuve);
    axios
      .post(
        `https://sportips.fr/plateformeResultats/getAncienneEpreuve.php`,
        data
      )
      .then(function (response) {
        _this.coureurs = response.data;
        _this.epreuve.nom = _this.coureurs[0].competition;
        _this.epreuve.ville = _this.coureurs[0].ville_compet;
        _this.epreuve.date = _this.coureurs[0].date_compet;
        _this.buildListParcours();
        _this.buildListCategories();
        _this.buildListClubs();
        _this.getInscritsInfos();
      });
  },
  watch: {
    $route(to, from) {
      this.reloadPage(to.query.p);
    }
  }
};
</script>


<style scoped>
.button_course {
  margin: 2px;
}

.button_course a {
  color: inherit !important;
}

.isCurrent {
  background-color: white !important;
  color: #f29406 !important;
}

.table-sm td.leftAlign {
  text-align: left !important;
}
</style>
